<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';

  export let item;
  export let currency;
  export let compact = false;
</script>

{#if compact}
  <small>{item.label}: {item.hours}h labor {minorToMoney(item.subtotalMinor, currency)} + fixed {minorToMoney(item.fixedCostMinor || 0, currency)}</small>
{:else}
  <article class="bit-card">
    <div>
      <h3>{item.label}</h3>
      <p>{item.hours}h</p>
    </div>
    <div class="rate-stack">
      <span>labor {minorToMoney(item.subtotalMinor, currency)}</span>
      <span>fixed cost {minorToMoney(item.fixedCostMinor || 0, currency)}</span>
    </div>
  </article>
{/if}
